import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CorporateService } from 'src/app/services/corporate.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';
import { EditLicenseDialogComponent } from '../../accounts/view-account/license-details/edit-license-dialog/edit-license-dialog.component';
// tslint:disable-next-line:max-line-length
import { RenewLicenseDialogComponent } from '../../accounts/view-account/license-details/renew-license-dialog/renew-license-dialog.component';
import { RemoveAddonDialogComponent } from '../../accounts/view-account/license-details/remove-addon-dialog/remove-addon-dialog.component';
import { BranchLicenseConfirmComponent } from './branch-license-confirm/branch-license-confirm.component';
import { RevertCorpAddonDialogComponent } from '../../accounts/view-account/license-details/revert-corp-addon/revert-corp-addon-dialog.component';
import { AddAddonDialoggComponent } from '../../accounts/view-account/license-details/add-addon-dialogg/add-addon-dialogg.component';

@Component({
  selector: 'app-corporate-license',
  templateUrl: './corporate-license.component.html',
  styleUrls: ['./corporate-license.component.css']
})
export class CorporateLicenseComponent implements OnInit {
  data: any;
  corporateId: any;
  licenseDetails: any;
  showrenewbtn = true;
  license_downgrade: any;
  corporateAddons: any = [];
  addonDownGraded: any = [];
  addon_downgrade: any;
  licenseDownGrade: string;
  licensePackages: any = [];
  addons: any = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private corporateService: CorporateService,
    private accountService: AccountService,
    private location: Location,
    
    private dialog: MatDialog) {

      this.accountService.getLicensePackages()
      .subscribe(res => {
        this.licensePackages = res;
      });
      // get addonmetadata
      this.accountService.getupgradableAddons()
      .subscribe(res => {
       this.addons = res;
      });
     }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.data = params;
      this.corporateId = this.data.corporateId;
      this.getLicenseDetails(this.corporateId);
      this.getAddonDetails(this.corporateId);
    });
  }
  getLicenseDetails(id) {
    this.corporateService.getLicenseDetails(id)
    .subscribe(res => {
      this.licenseDetails = res;
      this.license_downgrade = '';
      if (this.licenseDetails.downgradTo !== undefined) {
      this.license_downgrade = this.licenseDetails.downgradTo;
      this.licenseDownGrade = this.getDowngradedLicense(this.license_downgrade);
      }
      if (this.licenseDetails.type === 'Production') {
        this.showrenewbtn = false;
      }
    });
  }

  getAddonDetails(id) {
    this.corporateService.getAddons(id)
    .subscribe(res => {
     this.corporateAddons = res;
     console.log(JSON.stringify(this.corporateAddons));
      if (this.corporateAddons) {
        this.addonDownGraded = [];
       this.corporateAddons.forEach(addons => {
         if (addons.downgradTo) {
           this.addon_downgrade = addons.downgradTo;
            this.addonDownGraded.push({'downgradedAddon': this.getDowngradedAddon(this.addon_downgrade)});
         }
       });
      }
   
       // console.log(this.license_downgrade);
       // if (this.license_downgrade !== '') {
       //   for (let i = 0; i < this.licensePackages.length; i++) {
       //     if (this.licensePackages[i].pkgId === this.license_downgrade) {
       //       this.downgradeLicense = this.licensePackages[i].pkgName;
       //     }
       //   }
       // }
      // this.addonlist = this.licenseDetails.addons;

    });
  }
  goBacktoList() {
    this.location.back();
 }

 revert(addoncorplicense) {
  const dialogRef = this.dialog.open( RevertCorpAddonDialogComponent, {
    width: '600px',
    data: {'corpId': this.corporateId, 'addoncorplicense': addoncorplicense}
  });

  dialogRef.afterClosed().subscribe(result => {
    this.getLicenseDetails(this.corporateId);
    this.getAddonDetails(this.corporateId);

  });

}

 getDowngradedLicense(license) {
  let licenseName = '';
  if (license !== '') {
    for (let i = 0; i < this.licensePackages.length; i++) {
      if (this.licensePackages[i].pkgId === license) {
        licenseName = this.licensePackages[i].pkgName;
        break;
      }
    }
  }
 return licenseName;
}
getDowngradedAddon(addon) {
 let addonName = '';
 for ( let i = 0; i < this.addons.length; i++) {
    for (let j = 0; j < this.addons[i].addons.length; j++) {
      if (this.addons[i].addons[j].addonId === addon) {
        addonName = this.addons[i].addons[j].addonName;
        break;
      }
    }
}
return addonName;
}

 addAddons() {
  const dialogRef = this.dialog.open( AddAddonDialoggComponent, {
    width: '600px',
    data: {'corpId': this.corporateId, 'addon': this.corporateAddons, 'type': 'corporate'}

  });

  dialogRef.afterClosed().subscribe(result => {
       this.getLicenseDetails(this.corporateId);
       this.getAddonDetails(this.corporateId);

  });

}
changeLicense() {
  const dialogRef = this.dialog.open(EditLicenseDialogComponent, {
    width: '600px',
    // tslint:disable-next-line:max-line-length
    data: {'corpId': this.corporateId, 'licensedetails': this.licenseDetails, 'downgradeLicense': this.license_downgrade, 'type': 'corporate'}
  });

  dialogRef.afterClosed().subscribe(result => {
    this.getLicenseDetails(this.corporateId);

  });
}
 renewLicense() {

  const dialogRef = this.dialog.open(RenewLicenseDialogComponent, {
    width: '600px',
    data: {'corpId': this.corporateId, 'type': 'corporate'}

  });

  dialogRef.afterClosed().subscribe(result => {
      this.getLicenseDetails(this.corporateId);

  });

}

updateBranchLicense() {
  const dialogRef = this.dialog.open(BranchLicenseConfirmComponent, {
    width: '600px',
    // tslint:disable-next-line:max-line-length
    data: {'corpId': this.corporateId, 'type': 'updateBranchLicense', 'title': 'Update Branch License'}
  });

  dialogRef.afterClosed().subscribe(result => {
    this.getLicenseDetails(this.corporateId);

  });
}

updateBranchAddon() {
  const dialogRef = this.dialog.open(BranchLicenseConfirmComponent, {
    width: '600px',
    // tslint:disable-next-line:max-line-length
    data: {'corpId': this.corporateId, 'type': 'updateBranchAddon', 'title': 'Update Branch Addon'}
  });

  dialogRef.afterClosed().subscribe(result => {
    this.getLicenseDetails(this.corporateId);

  });
}
renewBranchLicense() {
  const dialogRef = this.dialog.open(BranchLicenseConfirmComponent, {
    width: '600px',
    // tslint:disable-next-line:max-line-length
    data: {'corpId': this.corporateId, 'type': 'renewBranchLicense', 'title': 'Renew Branch License'}
  });

  dialogRef.afterClosed().subscribe(result => {
    this.getLicenseDetails(this.corporateId);

  });
}
removeAddon(addon) {
  console.log(JSON.stringify(addon));
  const dialogRef = this.dialog.open(RemoveAddonDialogComponent, {
    width: '600px',
    data: {'corpId': this.corporateId, 'addonId': addon.addonId, 'type': 'corporate'}

  });

  dialogRef.afterClosed().subscribe(result => {
      this.getLicenseDetails(this.corporateId);
      this.getAddonDetails(this.corporateId);
  });
}

}
